var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    rx: 40,
    fill: "#F1F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.437 118.721L120.379 150.776C120.379 150.776 131.779 147.216 148.164 152.913C150.92 153.871 155.532 149.259 154.574 146.503C148.877 130.118 152.437 118.721 152.437 118.721Z",
    fill: "url(#paint0_linear_12691_144235)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6389 64.9797C86.1031 45.5185 117.702 45.5185 137.167 64.9797C156.628 84.4439 156.628 116.043 137.167 135.507C117.702 154.969 86.1031 154.969 66.6389 135.507C47.1777 116.043 47.1777 84.4439 66.6389 64.9797Z",
    fill: "url(#paint1_linear_12691_144235)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.72 59.5332C132.981 61.1381 135.139 62.9546 137.167 64.9796C156.628 84.4438 156.628 116.043 137.167 135.507C117.703 154.968 86.1036 154.968 66.6393 135.507C65.4938 134.359 64.4148 133.171 63.4023 131.947C82.2681 138.076 103.83 133.651 118.809 118.672C134.785 102.696 138.757 79.2302 130.72 59.5332Z",
    fill: "#E5EEF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3663 60.7061C84.188 38.8844 119.62 38.8844 141.441 60.7061C163.263 82.5278 163.263 117.959 141.441 139.781C119.62 161.603 84.188 161.603 62.3663 139.781C40.5446 117.959 40.5446 82.5278 62.3663 60.7061ZM68.7768 67.1166C87.0593 48.8341 116.748 48.8341 135.031 67.1166C153.313 85.3991 153.313 115.088 135.031 133.371C116.748 151.653 87.0593 151.653 68.7768 133.371C50.4943 115.088 50.4943 85.3991 68.7768 67.1166Z",
    fill: "url(#paint2_linear_12691_144235)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8092 125.107C41.4363 104.195 44.9544 78.1181 62.3664 60.7061C78.7176 44.3549 102.709 40.2566 122.896 48.411C123.041 50.2637 123.117 52.1406 123.117 54.0357C123.117 55.4985 123.071 56.9523 122.984 58.397C105.42 49.5535 83.4356 52.461 68.7769 67.1166C53.2388 82.6547 50.9055 106.432 61.7831 124.445C58.5975 124.881 55.3454 125.107 52.0449 125.107H51.8092Z",
    fill: "url(#paint3_linear_12691_144235)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.713 163.289C140.403 157.978 140.403 149.367 145.713 144.054C151.024 138.744 159.637 138.744 164.948 144.054L208.76 187.867C209.939 189.045 206.587 194.313 201.28 199.621C195.973 204.928 190.705 208.28 189.526 207.101L145.713 163.289Z",
    fill: "url(#paint4_linear_12691_144235)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.713 163.289C140.403 157.978 140.403 149.367 145.713 144.054C151.024 138.744 159.637 138.744 164.948 144.054L204.602 183.708C205.78 184.887 202.428 190.155 197.121 195.462C191.814 200.769 186.546 204.121 185.367 202.942L145.713 163.289Z",
    fill: "url(#paint5_linear_12691_144235)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.499 90.7268C95.4294 87.8464 96.5115 85.7428 98.1798 84.5097C100.803 82.5754 104.723 82.657 106.851 85.0537C107.764 86.0844 108.293 87.5412 108.308 89.3848C108.344 93.8066 106.271 96.3908 104.24 99.0656C101.507 102.671 98.7783 106.377 98.4398 112.564C98.3491 114.232 99.6306 115.656 101.296 115.746C102.961 115.837 104.388 114.558 104.479 112.893C104.732 108.193 106.981 105.455 109.057 102.717C111.838 99.0505 114.404 95.3934 114.353 89.3365C114.322 85.7761 113.135 83.0287 111.37 81.04C107.247 76.3976 99.6759 75.8959 94.5922 79.6437C91.5457 81.8923 89.3303 85.6159 89.4542 90.8688C89.4935 92.5372 90.8807 93.858 92.5491 93.8187C94.2144 93.7794 95.5383 92.3951 95.499 90.7268Z",
    fill: "url(#paint6_linear_12691_144235)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.178 126.972C103.232 126.972 104.896 125.308 104.896 123.255C104.896 121.202 103.232 119.537 101.178 119.537C99.1253 119.537 97.4609 121.202 97.4609 123.255C97.4609 125.308 99.1253 126.972 101.178 126.972Z",
    fill: "url(#paint7_linear_12691_144235)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.571 48.601L164.638 33.489C165.497 32.0594 165.034 30.2007 163.602 29.3423C162.172 28.487 160.313 28.9494 159.455 30.379L150.388 45.491C149.529 46.9236 149.995 48.7824 151.424 49.6377C152.857 50.4961 154.713 50.0336 155.571 48.601Z",
    fill: "url(#paint8_linear_12691_144235)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.87 58.5595L203.116 34.3804C204.464 33.3981 204.763 31.5061 203.784 30.1581C202.802 28.8071 200.91 28.5109 199.562 29.4901L166.315 53.6693C164.964 54.6516 164.668 56.5436 165.647 57.8916C166.63 59.2426 168.522 59.5388 169.87 58.5595Z",
    fill: "url(#paint9_linear_12691_144235)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.871 77.1809L199.05 71.1361C200.67 70.7311 201.656 69.0899 201.251 67.4699C200.846 65.8529 199.205 64.8676 197.585 65.2726L173.405 71.3174C171.788 71.7224 170.803 73.3636 171.208 74.9836C171.613 76.6006 173.254 77.5859 174.871 77.1809Z",
    fill: "url(#paint10_linear_12691_144235)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12691_144235",
    x1: 149.959,
    y1: 123.254,
    x2: 141.267,
    y2: 153.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12691_144235",
    x1: 66.9441,
    y1: 72.2455,
    x2: 136.786,
    y2: 135.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12691_144235",
    x1: 117.709,
    y1: 52.9416,
    x2: 137.881,
    y2: 143.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12691_144235",
    x1: 71.1404,
    y1: 50.3846,
    x2: 96.5528,
    y2: 127.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12691_144235",
    x1: 186.386,
    y1: 165.492,
    x2: 171.754,
    y2: 193.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12691_144235",
    x1: 182.556,
    y1: 161.663,
    x2: 170.612,
    y2: 188.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12691_144235",
    x1: 89.4511,
    y1: 77.2711,
    x2: 104.896,
    y2: 126.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12691_144235",
    x1: 89.4516,
    y1: 77.2719,
    x2: 104.896,
    y2: 126.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12691_144235",
    x1: 189.174,
    y1: 39.3313,
    x2: 152.201,
    y2: 66.8321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12691_144235",
    x1: 189.174,
    y1: 39.331,
    x2: 152.201,
    y2: 66.8318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12691_144235",
    x1: 189.176,
    y1: 39.3314,
    x2: 152.203,
    y2: 66.8322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.a0717c6f0fc9ae7623d02ed4bfc1b050.svg";
export { ForwardRef as ReactComponent };